import React, { FC } from 'react';
import { Box, CircularProgress, Dialog } from '@mui/material';

interface TwQBOLoaderProps {
  open: boolean;
}

const TwQBOLoader: FC<TwQBOLoaderProps> = ({ open }) => {
  return (
    <Dialog open={open}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '48px',
          width: '400px',
          height: '200px'
        }}
      >
        <CircularProgress size={32} sx={{ marginBottom: '24px' }} />
        <Box
          component="p"
          sx={{
            margin: 0,
            fontSize: '16px',
            fontWeight: 500
          }}
        >
          Generating preview
        </Box>
        <Box component="span" sx={{ fontSize: '14px' }}>
          Might take a few seconds
        </Box>
      </Box>
    </Dialog>
  );
};

export default TwQBOLoader;
